module.exports = __webpack_public_path__ + "static/media/eth.80583803.svg";